import { useCallback, useMemo } from 'react';
import { useRouter } from 'next/router';

interface SearchFilters {
  query: string;
  category: string;
}

export function useSearch() {
  const router = useRouter();

  const filters: SearchFilters = useMemo(() => ({
    query: (router.query.q as string) || '',
    category: (router.query.category as string) || '',
  }), [router.query.q, router.query.category]);

  const updateParams = useCallback((updates: Partial<SearchFilters>) => {
    const newQuery = { ...router.query };

    if ('query' in updates) {
      if (updates.query) {
        newQuery.q = updates.query;
      } else {
        delete newQuery.q;
      }
    }

    if ('category' in updates) {
      if (updates.category) {
        newQuery.category = updates.category;
      } else {
        delete newQuery.category;
      }
    }

    // Use shallow routing — no SSR re-fetch, just URL update
    router.replace(
      { pathname: router.pathname, query: newQuery },
      undefined,
      { shallow: true }
    );
  }, [router]);

  const setQuery = useCallback((query: string) => {
    updateParams({ query });
  }, [updateParams]);

  const setCategory = useCallback((category: string) => {
    updateParams({ category });
  }, [updateParams]);

  return { filters, setQuery, setCategory };
}
